<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="0310262984_content_0003_002" id="d12e79" src="images/0310262984_content_0003_002.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Tada_9780310297864_epub_c2a_r1.vue?1f0c11b3